import { render, staticRenderFns } from "./TouristFeed.vue?vue&type=template&id=db57756a&"
import script from "./TouristFeed.vue?vue&type=script&lang=ts&"
export * from "./TouristFeed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports